// based off React's ExecutionEnvironment canUseDOM
export default () => Boolean(typeof window !== 'undefined' && window.document);
